export enum ChoiceType {
    Agree = "Agree",
    Disagree = "Disagree",
    Neutral = "Neutral",
}